// Maison — comportements des sections lt-* (carrousel d'avis, « Voir plus »)
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-lt-carrousel]:not([data-pret])').forEach((c) => {
      c.dataset.pret = '1';
      const piste = c.querySelector('[data-lt-piste]'), pts = c.querySelector('[data-lt-points]');
      if (!piste || !pts) return;
      const pages = () => Math.max(1, Math.ceil(piste.scrollWidth / piste.clientWidth - 0.05));
      const maj = () => { const i = Math.round(piste.scrollLeft / piste.clientWidth); pts.querySelectorAll('button').forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false')); };
      const dessine = () => {
        pts.innerHTML = '';
        const n = pages(); if (n < 2) return;
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `Page ${i + 1}`);
          b.addEventListener('click', () => piste.scrollTo({ left: i * piste.clientWidth, behavior: 'smooth' }));
          pts.appendChild(b);
        }
        maj();
      };
      piste.addEventListener('scroll', () => requestAnimationFrame(maj), { passive: true });
      window.addEventListener('resize', dessine);
      dessine();
    });
    root.querySelectorAll('[data-lt-replie]:not([data-pret])').forEach((r) => {
      r.dataset.pret = '1';
      const b = r.querySelector('button');
      b?.addEventListener('click', () => { const o = r.classList.toggle('est-ouvert'); b.setAttribute('aria-expanded', o); b.textContent = o ? b.dataset.moins : b.dataset.plus; });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

// Mini-avis de la fiche produit (flèches, tirets, défilement auto 5 s) + bouton « Commander maintenant » qui ramène au bouton d'achat
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-lt-mini]:not([data-pret])').forEach((m) => {
      m.dataset.pret = '1';
      const piste = m.querySelector('.lt-mini__piste'), n = piste?.children.length || 0, pts = m.querySelector('[data-points]');
      if (n < 2) { m.querySelectorAll('.lt-mini__fl').forEach((b) => b.remove()); return; }
      let i = 0, t;
      pts.innerHTML = Array.from({ length: n }, () => '<span></span>').join('');
      const va = (k) => { i = (k + n) % n; piste.style.transform = `translateX(-${i * 100}%)`; pts.querySelectorAll('span').forEach((s, j) => s.classList.toggle('actif', j === i)); };
      const auto = () => { clearInterval(t); t = setInterval(() => va(i + 1), 5000); };
      m.querySelectorAll('.lt-mini__fl').forEach((b) => b.addEventListener('click', () => { va(i + Number(b.dataset.dir)); auto(); }));
      va(0); auto();
    });
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-lt-vers-achat]'); if (!a) return;
    e.preventDefault();
    document.querySelector('.product-details button[name="add"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

// Barre d'achat fixe : ajoute « | prix » au texte du bouton, comme sur FullStack
(() => {
  const maj = () => document.querySelectorAll('.sticky-add-to-cart__bar').forEach((bar) => {
    const prix = bar.querySelector('.sticky-add-to-cart__price .price')?.textContent.trim();
    const cible = bar.querySelector('.add-to-cart-text__content > span:first-child');
    if (!prix || !cible) return;
    const base = cible.dataset.ltBase || cible.textContent.trim();
    cible.dataset.ltBase = base;
    const txt = `${base}  |  ${prix}`;
    if (cible.textContent !== txt) { cible.textContent = txt; cible.style.whiteSpace = 'pre'; }
  });
  const go = () => { maj(); new MutationObserver(maj).observe(document.body, { subtree: true, childList: true, characterData: true }); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
})();

// Panneau de filtres : toutes les rubriques dépliées comme sur FullStack
(() => {
  const ouvre = () => document.querySelectorAll('#filters-drawer details').forEach((d) => { d.open = true; });
  const go = () => { ouvre(); new MutationObserver(ouvre).observe(document.body, { subtree: true, childList: true }); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
})();

// Clic sur le voile sombre : ferme le panneau de filtres
document.addEventListener('click', (e) => {
  const d = document.querySelector('#filters-drawer .theme-drawer__dialog[open]');
  if (!d || d.contains(e.target) || e.target.closest('.facets-toggle__button')) return;
  d.querySelector('.theme-drawer__close-button')?.click();
});

// LT-COINS-SLIDES — flèches gauche/droite sur les carrousels (cachées s'il n'y a rien à faire défiler)
(() => {
  const SEL = '.lt-collections .lt-grille4, .lt-produits .lt-grille4, [class*="pourquoi-grid-"], .lt-slide';
  const svg = d => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="' + d + '"/></svg>';
  const init = (root = document) => root.querySelectorAll(SEL).forEach((piste) => {
    if (piste.dataset.ltSlide) return; piste.dataset.ltSlide = '1';
    const zone = piste.parentElement; zone.classList.add('lt-slide-zone');
    const g = document.createElement('button'), d = document.createElement('button');
    g.type = d.type = 'button'; g.className = 'lt-fleche lt-fleche--g'; d.className = 'lt-fleche lt-fleche--d';
    g.setAttribute('aria-label', 'Précédent'); d.setAttribute('aria-label', 'Suivant');
    g.innerHTML = svg('M15 5l-7 7 7 7'); d.innerHTML = svg('M9 5l7 7-7 7');
    zone.append(g, d);
    const pas = () => { const c = piste.children[0]; return c ? c.getBoundingClientRect().width + 16 : piste.clientWidth * 0.8; };
    g.addEventListener('click', () => piste.scrollBy({ left: -pas(), behavior: 'smooth' }));
    d.addEventListener('click', () => piste.scrollBy({ left: pas(), behavior: 'smooth' }));
    const maj = () => { const max = piste.scrollWidth - piste.clientWidth - 2; g.disabled = piste.scrollLeft <= 2; d.disabled = piste.scrollLeft >= max || max <= 0; };
    piste.addEventListener('scroll', () => requestAnimationFrame(maj), { passive: true }); window.addEventListener('resize', maj); maj(); setTimeout(maj, 600);
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
// FIN LT-COINS-SLIDES

// LT-QTE — prix du bouton « Ajouter au panier » = prix unitaire × quantité choisie (demande du 27/10)
(() => {
  const euros = (c) => (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const maj = () => {
    const champ = document.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    const q = Math.max(1, parseInt(champ && champ.value, 10) || 1);
    document.querySelectorAll('.lt-atc-prix[data-lt-unite]').forEach((el) => { el.textContent = euros(+el.dataset.ltUnite * q); });
  };
  ['input', 'change', 'click'].forEach((ev) => document.addEventListener(ev, (e) => { if (e.target.closest && e.target.closest('quantity-selector-component, .quantity-selector, input[name="quantity"]')) setTimeout(maj, 50); }));
  new MutationObserver(() => setTimeout(maj, 50)).observe(document.documentElement, { childList: true, subtree: true });
})();
// FIN LT-QTE

/* LT-BARRE (29/10) : sur mobile, la barre « Ajouter au panier » est visible dès l'arrivée sur la fiche
   et se cache seulement quand le vrai bouton est à l'écran */
(function () {
  var btn = document.querySelector('product-form-component button[name="add"], form[action*="/cart/add"] button[name="add"]');
  if (!btn || !('IntersectionObserver' in window)) return;
  document.body.classList.add('lt-achat-visible');
  new IntersectionObserver(function (e) { document.body.classList.toggle('lt-bouton-visible', e[0].isIntersecting); }).observe(btn);
})();

/* LT-VARIANTES (29/10) : si un intitulé de variante passe sur 2 lignes, la grille passe à 2 colonnes (recalculé à chaque changement) */
(function () {
  function regle() {
    document.querySelectorAll('.variant-option--buttons').forEach(function (g) {
      g.classList.remove('lt-2col');
      var trop = [].some.call(g.querySelectorAll('.variant-option__button-label__text'), function (t) { return t.getClientRects().length > 1 || t.offsetHeight > 24; });
      if (trop) g.classList.add('lt-2col');
    });
  }
  regle(); window.addEventListener('resize', regle);
  var vp = document.querySelector('variant-picker, .variant-picker');
  if (vp && 'MutationObserver' in window) new MutationObserver(function () { requestAnimationFrame(regle); }).observe(vp.parentNode || vp, { childList: true, subtree: true });
})();
// Filtres verticaux ouverts (03/11) : sur ordinateur, toutes les rubriques de filtres restent dépliées
(() => {
  const ouvre = () => { if (innerWidth < 990) return; document.querySelectorAll('.facets--vertical details').forEach((d) => { d.open = true; d.setAttribute('open', ''); }); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ouvre) : ouvre();
  document.addEventListener('shopify:section:load', ouvre);
  new MutationObserver(() => ouvre()).observe(document.documentElement, { childList: true, subtree: true });
})();
// fin filtres ouverts
